<mat-card>
  <!-- Content -->
  <mat-card-content>
    <div class="margin s5 bottom top">
      <div class="mat-subtitle-1 margin padding s5 top">
        {{ 'Generic_Roles' | translate }}
      </div>
      <div>
        @for (role of roles; track role) {
          <mat-checkbox
            color="primary"
            (click)="roleSelect(role)"
            [checked]="role.isSelected"
          >
            {{ role.name }}
          </mat-checkbox>
          &nbsp;
        }
      </div>
    </div>
    <div class="margin padding s5 bottom top">
      <div class="mat-subtitle-1 margin padding s5 bottom top">
        {{ 'Custom_Roles' | translate }}
      </div>

      <div class="input-container">
        <mat-form-field subscriptSizing="dynamic" appearance="outline"  floatLabel="always" >
          <mat-label>{{'Role_Name' | translate}}</mat-label>
          <input matInput [(ngModel)]="inputValue" placeholder="Role Name"
        /></mat-form-field>
        <div
          matRipple
          matRippleColor="primary"
          class="btn-arrow"
          (click)="input($event)"
        >
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div>

      <div class="custom-roles">
        <mat-chip-set>
          @for (role of customRoles; track role) {
          <mat-chip
            (removed)="removeRole(role)"
          >
            {{ role.name }}
            <span matChipRemove [attr.aria-label]="'remove ' + role" >
              <mat-icon>cancel</mat-icon>
            </span></mat-chip
          >
          }
        </mat-chip-set>
      </div>
    </div>
  </mat-card-content>

  <!-- Footer -->
  <mat-card-actions>
    <button mat-stroked-button color="primary" (click)="close()">
      {{ 'BUTTONS.close' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="saveData()">
      {{ 'BUTTONS.save' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
